import { getApp, getApps, initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDu7AjVlr3i9gs5cLs7LjxmtJB6QBYuzWE",
  authDomain: "playmatez-38cf6.firebaseapp.com",
  databaseURL: "https://playmatez-38cf6-default-rtdb.firebaseio.com",
  projectId: "playmatez-38cf6",
  storageBucket: "playmatez-38cf6.firebasestorage.app",
  messagingSenderId: "109442322016",
  appId: "1:109442322016:web:d0915b6151d40590933d05",
  measurementId: "G-4LB8BQ466Q",
};

// ✅ Prevent duplicate initialization
const app = getApps()?.length === 0 ? initializeApp(firebaseConfig) : getApp();

export const messaging = getMessaging(app);
